/**
 * Copies the provided text to the clipboard.
 *
 * @param {string} text - The text to be copied to the clipboard.
 * @param {Function} [callback] - An optional callback function to be executed after the text is copied.
 * @returns {Promise<void>} - A promise that resolves when the text has been successfully copied.
 */
async function copyToClipboard(text, callback) {
  await navigator.clipboard.writeText(text);
  callback?.();
}

export default copyToClipboard;
